import { FC, useCallback } from 'react';

import { Button, Icon } from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import { TooltipWrapper } from '../TooltipWrapper/TooltipWrapper';

import classes from './FullscreenModeButton.module.scss';

export interface FullscreenModeButtonProps {
  fullscreen: boolean;
  openFullscreen: () => void;
  closeFullscreen: () => void;
}

export const FullscreenModeButton: FC<FullscreenModeButtonProps> = ({
  fullscreen,
  openFullscreen,
  closeFullscreen,
}) => {
  const toggleFullscreen = useCallback(() => {
    if (fullscreen) {
      closeFullscreen();
    } else {
      openFullscreen();
    }
  }, [closeFullscreen, fullscreen, openFullscreen]);

  return (
    <TooltipWrapper
      title={
        fullscreen
          ? 'Выйти из полноэкранного режима'
          : 'Открыть в полноэкранном режиме'
      }
    >
      <Button
        size='medium'
        startIcon={
          <Icon iconName={fullscreen ? Icons.Collapse : Icons.Expand} />
        }
        onClick={toggleFullscreen}
        className={classes.container}
      />
    </TooltipWrapper>
  );
};
